import { Item } from './Item'

export function List({ data, infoLigacoes }) {
  return data?.map((item, index) => <Item key={index} infoLigacoes={infoLigacoes} data={item} odd={index % 2 === 0} />)
}
